var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container"},_vm._l((_vm.states),function(agents,state){return _c('ul',{key:state},[_c('li',[_c('strong',[_vm._v(_vm._s(state)+" ( "+_vm._s(agents.length)+" )")]),_c('ul',_vm._l((agents),function(agent){return _c('li',{key:agent.agentId},[_vm._v(" "+_vm._s(agent.agentName)+" ")])}),0)])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }